"use client";
import React, { useState, useRef, useEffect } from "react";

const RentalsContent = ({ content }) => {
  const [showFullContent, setShowFullContent] = useState(false);
  const contentRef = useRef(null);

  const toggleContent = () => setShowFullContent((prev) => !prev);

  const isScrollable = content && content.length > 1000;

  useEffect(() => {
    if (showFullContent && contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [showFullContent]);

  return (
    <div className="dynamic-code-content">
      <div
        ref={contentRef}
        className={
          showFullContent
            ? "max-h-none overflow-y-auto text-center mx-auto w-full relative transition-[max-height] duration-300 ease-in-out max-[844px]:max-h-[600px] [&::-webkit-scrollbar]:w-[5px] [&::-webkit-scrollbar-thumb]:bg-textMuted [&::-webkit-scrollbar-thumb]:rounded"
            : "max-h-[550px] overflow-hidden w-full relative transition-[max-height] duration-300 ease-in-out max-[844px]:max-h-[400px]"
        }
        id="long-content"
      >
        <div
          className="text-base font-normal leading-[1.6] text-textSecondary max-w-[92%] text-center mx-auto block max-[844px]:text-sm max-[844px]:max-w-[90%] max-[844px]:mt-[10px]"
          dangerouslySetInnerHTML={{ __html: content || "" }}
        />
      </div>

      {isScrollable && (
        <button
          type="button"
          className="font-medium mt-[13px] cursor-pointer text-textPrimary hover:underline hover:text-primary min-h-[44px] min-w-[44px] px-1 py-2"
          onClick={toggleContent}
          aria-expanded={showFullContent}
          aria-controls="long-content"
        >
          {showFullContent ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
  );
};

export default RentalsContent;

